<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" @visible-change="getSupplier">
                    <el-option v-for="list in supplierList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.batch_no" placeholder="批次号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.ship_no" placeholder="船名" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getBreed">
                    <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getBrand">
                    <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.thickness" placeholder="厚度" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.length" placeholder="长度" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.kiln_no" placeholder="窑号" size="mini"></el-input>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="startintime" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入窑时间"></el-date-picker>
                    ~
                    <el-date-picker v-model="endintime" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入窑时间"></el-date-picker>
                </div>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="startexptime" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="预计出窑时间"></el-date-picker>
                    ~
                    <el-date-picker v-model="endexptime" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="预计出窑时间"></el-date-picker>
                </div>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getDetail()">查询</el-button>
                    <!-- <el-button  class="publicBtn" @click="filterDialogVisible=!filterDialogVisible">过滤</el-button> -->
                </div>
                <!-- <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getDetail()">查询</el-button> -->
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="batchEdit">批量修改</el-button>
                <el-button class="funcPublicBtn" @click="batchDel">批量删除</el-button>
                <div class="machBack" @click="machBack">返回流程详情</div>
            </div>
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="selectChange" @getTableEdit="edit" @getTableDelete="del"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计</div>
                <div class="totalNumber">件数:{{totalObj.numbers}}</div>
                <div class="totalNumber">立方:{{totalObj.cube}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="processing.wet.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <el-dialog v-dialog-drag :visible.sync="editDialog" class="eldialog eldialogA" width="630px" :modal="false" title="修改" custom-class="full_dialog">
            <el-form  :model="editForm" class="clearfix">
                <div class="eldialogFormBox">
                    <el-form-item   label="供应商：">
                        <el-select v-model="editForm.supplier_id" clearable  @visible-change="getSupplier">
                            <el-option v-for="list in supplierList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item   label="合同号：">
                        <el-input v-model="editForm.contract_no"></el-input>
                    </el-form-item>
                    <el-form-item   label="批次号：">
                        <el-input v-model="editForm.batch_no"></el-input>
                    </el-form-item>
                    <el-form-item   label="船名：">
                        <el-input v-model="editForm.ship_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="品名：">
                        <el-select v-model="editForm.breed_id" clearable  @visible-change="getBreed">
                            <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="品牌：">
                        <el-select v-model="editForm.brand_id" clearable  @visible-change="getBrand">
                            <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item   label="捆包号：">
                        <el-input v-model="editForm.bale_no"></el-input>
                    </el-form-item>
                    <el-form-item   label="厚度：">
                        <el-input v-model="editForm.thickness"></el-input>
                    </el-form-item>
                    <el-form-item   label="片数：">
                        <el-input v-model="editForm.pieces"></el-input>
                    </el-form-item>
                    <el-form-item   label="长度：">
                        <el-input v-model="editForm.length"></el-input>
                    </el-form-item>
                    <el-form-item   label="码单立方：">
                        <el-input v-model="editForm.cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="湿板批次号：">
                        <el-input v-model="editForm.wet_wood_batch"></el-input>
                    </el-form-item>
                    <el-form-item   label="窑号：">
                        <el-input v-model="editForm.kiln_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="入窑时间：">
                        <el-date-picker v-model="editForm.kiln_in_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="预计入库时间：">
                        <el-date-picker v-model="editForm.expected_kiln_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="备注：">
                        <el-input v-model="editForm.remark"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="saveWet">确定保存</el-button>
                <el-button  class="funcPublicBtn dialogBtn" @click="editDialog=!editDialog">取消</el-button>
                <!-- <el-button class="dialogBtn funcPublicBtn"  @click="isShowContract=!isShowContract">关闭</el-button> -->
            </div>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title{text-align: center;font-size:18px; font-weight:bold; line-height:25px; color: #333333;padding-bottom:20px;}
</style>
<script>
    import pagination from '../../../components/pagination.vue'
    import tabletem from '../../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                isShowMore:false,
                processing_id:"",
                wet_wood_batch:"",
                start_time:"",
                end_time:"",
                startintime:"",
                endintime:"",
                startexptime:"",
                endexptime:"",
                module:localStorage.dw_erp_power_code,
                editDialog:false,
                editForm:{
                    processing_id:"",
                    id:"",
                    supplier_id:"",
                    contract_no:"",
                    batch_no:"",
                    ship_no:"",
                    breed_id:"",
                    brand_id:"",
                    bale_no:"",
                    thickness:"",
                    length:"",
                    pieces:"",
                    cube:"",
                    wet_wood_batch:"",
                    kiln_no:"",
                    kiln_in_time:"",
                    expected_kiln_time:"",
                    remark:""
                },
                selectList:[],
                params:{
                    processing_id:"",
                    wet_wood_batch:"",
                    start_time:"",
                    end_time:"",
                    supplier_id:"",
                    contract_no:"",
                    batch_no:"",
                    ship_no:"",
                    breed_id:"",
                    brand_id:"",
                    kiln_no:"",
                    thickness:"",
                    length:"",
                    startintime:"",
                    endintime:"",
                    startexptime:"",
                    endexptime:"",
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2单条，3多条
                list : [],
                breedList:[],
                brandList:[],
                supplierList:[],
                selectMap:{
                    user:[],
                    customerSource:[],
                    customerAttribute:[]
                },
                selectDialogVisible:false,
                // dialog START
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[	
                    {colName:"供应商",colKey:"supplier",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"总宽度",colKey:"width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"码单立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"湿板批次号",colKey:"wet_wood_batch",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"窑号",colKey:"kiln_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入窑时间",colKey:"kiln_in_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计出窑时间",colKey:"expected_kiln_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                // dialog END
                show_upload : false,
                totalObj:{}
            }
        },
        created(){
            this.processing_id = sessionStorage.getItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WETDETAIL")
            sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WETDETAIL")
            this.wet_wood_batch = sessionStorage.getItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WETDETAIL_BATCH")
            sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WETDETAIL_BATCH")
            this.getDetail()
            this.getBreed()
            this.getBrand()
            this.getSupplier()
        },
        methods:{
            machBack(){
                this.$root.$children[0].$children[0].addTab({
                    name: '加工单流程详情'+this.processing_id,
                    label: '加工单流程详情',
                    content: 'machiningFakeDetail'
                });
            },
            saveWet(){
                let url = "";
                if(this.updataType==3){
                    url = "/erp/processing.wet.updates";
                    let ids = [];
                    this.selectList.forEach(item=>{
                        ids.push(item.id)
                    })
                    this.editForm.id = ids;
                }else{
                    url = "/erp/processing.wet.update";
                }
                let kiln_in_time = this.editForm.kiln_in_time;
                let expected_kiln_time = this.editForm.expected_kiln_time;
                this.editForm.processing_id = this.processing_id;
                this.editForm.kiln_in_time = this.formatTimeZero(this.editForm.kiln_in_time);
                this.editForm.expected_kiln_time = this.formatTimeZero(this.editForm.expected_kiln_time);
                this.postFuncLoading(url,this.editForm,()=>{
                    this.tip("修改成功","success")
                    this.editDialog = false;
                    this.getDetail()
                },error=>{
                    this.editForm.kiln_in_time = kiln_in_time;
                    this.editForm.expected_kiln_time = expected_kiln_time;
                    this.tip(error.data.message,"warning")
                },()=>{
                    this.editForm.kiln_in_time = kiln_in_time;
                    this.editForm.expected_kiln_time = expected_kiln_time;
                })
            },
            delDetail(ids){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/processing.wet.delete",{processing_id:this.processing_id,id:ids},()=>{
                        this.tip("删除成功","success")
                        this.getDetail()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            batchDel(){
                let flag = true;
                if(this.selectList.length>0){
                    let ids = [];
                    this.selectList.forEach(item=>{
                        ids.push(item.id)
                        if(!item.isDelete){
                            flag = false;
                            this.tip("选中内容有不可删除项","warning")
                        }
                    })
                    if(flag){
                        this.delDetail(ids)
                    }
                }else{
                    this.tip("请选择内容","warning")
                }
            },
            batchEdit(){
                let flag = true;
                if(this.selectList.length>0){
                    this.selectList.forEach(item=>{
                        if(!item.isEdit){
                            flag = false;
                            this.tip("选中内容有不可修改项","warning")
                        }
                    })
                    if(flag){
                        this.updataType=3;
                        this.editDialog=true;
                    }
                }else{
                    this.tip("请选择内容","warning")
                }
            },
            getSupplier(){
                this.postFunc("/erp/processing.wet.supplier",{processing_id:this.processing_id},res=>{
                    this.supplierList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBrand(){
                this.postFunc("/erp/processing.wet.brand",{processing_id:this.processing_id},res=>{
                    this.brandList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBreed(){
                this.postFunc("/erp/processing.wet.breed",{processing_id:this.processing_id},res=>{
                    this.breedList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            filterConfirm(){
                this.getDetail()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time = "";
                this.end_time = "";
                this.startintime = "";
                this.endintime = "";
                this.startexptime = "";
                this.endexptime = "";
                this.params.processing_id = this.processing_id;
                this.params.wet_wood_batch = this.wet_wood_batch;
                this.getDetail()
            },
            selectChange(row){
                this.selectList=row;
            },
            del(id){
                this.delDetail([id])
            },
            edit(id){
                this.editDialog=true;
                this.updataType=2;
                this.list.forEach(item=>{
                    if(item.id==id){
                        let editForm=JSON.parse(JSON.stringify(item));
                        this.editForm = editForm;
                    }
                })
            },
            getDetail(){
                this.params.start_time = this.formatTimeZero(this.start_time)
                this.params.end_time = this.formatTimeZero(this.end_time)
                this.params.startintime = this.formatTimeZero(this.startintime)
                this.params.endintime = this.formatTimeZero(this.endintime)
                this.params.startexptime = this.formatTimeZero(this.startexptime)
                this.params.endexptime = this.formatTimeZero(this.endexptime)
                this.params.processing_id = this.processing_id;
                this.params.wet_wood_batch = this.wet_wood_batch;
                this.tableLoading = true;
                this.postFunc("/erp/processing.wet.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.totalObj = res.data.data.total;
                    this.list.forEach((item,index)=>{
                        if(item.expected_kiln_time!=0){
                            this.list[index].expected_kiln_time = this.formatTime(item.expected_kiln_time*1000)
                        }else{
                            this.list[index].expected_kiln_time = "";
                        }
                        if(item.kiln_in_time!=0){
                            this.list[index].kiln_in_time = this.formatTime(item.kiln_in_time*1000)
                        }else{
                            this.list[index].kiln_in_time = "";
                        }
                        item.width_total = this.keepLimit(item.width_total)
                        item.cube = this.keepLimit(item.cube)
                        // item.kiln_in_time = this.formatTime(item.kiln_in_time*1000)
                        // item.expected_kiln_time = this.formatTime(item.expected_kiln_time*1000)
                    })
                    this.filter = res.data.data.columns;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            }
        },
         watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "editDialog":function(val){
                if(!val){
                    this.editForm = this.resetJson(this.editForm)
                }
            }
        }
    }
</script>
